// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__uy4ge","loaderRotate":"Loader_loaderRotate__gWW1K"};